import { NativeDateAdapter } from '@angular/material/core'
import { Injectable } from '@angular/core'

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  override format(date: Date, displayFormat: object): string {
    const day = date.getDate()
    const month = date.getMonth() + 1
    const year = date.getFullYear()

    const formattedDay = day < 10 ? `0${day}` : day
    const formattedMonth = month < 10 ? `0${month}` : month

    return `${formattedDay}/${formattedMonth}/${year}`
  }

  override parse(value: any): Date | null {
    if (typeof value === 'number') {
      return new Date(value)
    }
    if (typeof value === 'string' && value.trim()) {
      const match = value.trim().match(/^(\d{1,2})\/(\d{1,2})\/(\d{2,4})$/)
      if (!match) return new Date(NaN)

      const day = Number(match[1])
      const month = Number(match[2])
      const year = Number(match[3]) < 100 ? Number(match[3]) + 2000 : Number(match[3])
      const date = new Date(year, month - 1, day)

      return date.getMonth() === month - 1 ? date : new Date(NaN)
    }
    return null
  }
}
